export default __webpack_public_path__ + "static/media/02AW2FEB66.1d744215.jpg";